"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFoundPage = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _shared = require("@zeus/shared");

var styles = _interopRequireWildcard(require("./not-found-page.module.scss"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFoundPage = function NotFoundPage(_ref) {
  var title = _ref.title,
      text = _ref.text,
      button = _ref.button;
  return /*#__PURE__*/_react.default.createElement(_shared.Section, {
    size: "lg"
  }, /*#__PURE__*/_react.default.createElement(_shared.Container, null, /*#__PURE__*/_react.default.createElement(_shared.Title, {
    wrapper: "h1",
    size: "s7"
  }, title), /*#__PURE__*/_react.default.createElement(_shared.Text, null, /*#__PURE__*/_react.default.createElement(_shared.Markdown, {
    content: text
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.button
  }, /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
    to: "/"
  }, "\u2190 ", button)))));
};

exports.NotFoundPage = NotFoundPage;
NotFoundPage.propTypes = {
  title: _propTypes.default.string.isRequired,
  text: _propTypes.default.string.isRequired,
  button: _propTypes.default.string.isRequired
};